import { useEffect, useState, useContext } from 'react';
import useToken from '../../hooks/useToken';

/**
 * Contexts
 */
import { AppContext } from '../../contexts/AppContext';

/**
 * Utils
 */
import { fetchReportsByPlanning } from '../../utils/api';
import { getCurrentUserStaffID } from '../../utils/staff';

/**
 * MUI Components
 */
import Chip from '@mui/material/Chip';

/**
 * Icons
 */
import DoneIcon from '@mui/icons-material/Done';

export default function PlanningReportCount({ planning }) {
    const { token } = useToken();
    const appData = useContext(AppContext);
    const sid = getCurrentUserStaffID(appData);
    const [reports, setReports] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!token || !planning?.id || !sid) return;

        const abortController = new AbortController();
        const loadReports = async () => {
            try {
                const params = {
                    staff_id: sid,
                    only_owner: true,
                };
                const result = await fetchReportsByPlanning(token, planning.id, params, abortController.signal);
                if (result?.success && Array.isArray(result.reports)) {
                    setReports(result.reports);
                } else {
                    setReports([]);
                }
            } catch (error) {
                if (error.name !== 'AbortError') {
                    console.error('Error loading reports:', error);
                }
            } finally {
                setIsLoading(false);
            }
        };

        loadReports();

        return () => abortController.abort();
    }, [token, planning?.id, sid]);

    if (isLoading) return null;

    const reportCount = reports.length;
    const userHasReport = reports.some(report => report.staff_id == sid);

    console.debug(reportCount, userHasReport, sid, reports);

    return (
        <Chip
            label={reportCount}
            size="small"
            color={userHasReport ? "success" : "primary"}
            icon={userHasReport ? <DoneIcon /> : null}
        />
    );
}
